export default __webpack_public_path__ + "static/squatting-112996f53d4a3b8cb8d7fd91af81dbb7.svg";